import React from "react"
import type { ViewProps } from "react-native"
import { StyleSheet, View } from "react-native"

import { renderIconFromIconProp } from "@/theme/icons/renderIconFromIconProp"
import { SPACING } from "@/theme/theme"

import { Box } from "./Box"
import { Heading } from "./Heading"
import { Row } from "./Row"
import type { WithOptionalTestId } from "./test-id"
import { testIds } from "./test-id"
import { AppText } from "./Text"

import type { HeadingProps } from "./Heading"
import type { AppTextProps } from "./Text"

import type { MenuItemProps } from "./Menu"
// const styles = StyleSheet.create({
//   listItemLoader: {
//     bottom: 0,
//     left: 0,
//     opacity: 30,
//     position: "absolute",
//     right: 0,
//     top: 0,
//   },
// })

type ListItemTextProps = AppTextProps

export function ListItemTextPrimary({
  children,
  ...rest
}: ListItemTextProps): React.JSX.Element | null {
  return <AppText {...rest}>{children}</AppText>
}

export function ListItemTextSecondary({
  children,
  ...rest
}: ListItemTextProps): React.JSX.Element | null {
  return (
    <AppText colorScheme={"secondary"} {...rest}>
      {children}
    </AppText>
  )
}

const styles = StyleSheet.create({
  listItemContainer: {
    paddingHorizontal: SPACING.$4,
    paddingVertical: SPACING.$3,
    width: "100%",
  },
})

export const ListItemContainer = React.forwardRef<
  View,
  WithOptionalTestId<ViewProps>
>(function ListItemContainer({ id, preserveId, style, ...rest }, ref) {
  return (
    <View
      {...testIds(id, { preserveId })}
      ref={ref}
      style={[styles.listItemContainer, style]}
      {...rest}
    />
  )
})

export type ListItemProps = MenuItemProps
/**
 *
 */
export const ListItem = React.forwardRef<View, ListItemProps>(
  function ListItem(
    { EndComponent, IconComponent, id, style, text, ...rest },
    ref,
  ) {
    let loaderElement: React.JSX.Element | undefined

    const iconElement = renderIconFromIconProp(IconComponent)

    return (
      <ListItemContainer ref={ref} id={id} style={style} {...rest}>
        <Row flexWrap={"nowrap"}>
          {loaderElement}
          {iconElement ? <Box mr={"$2"}>{iconElement}</Box> : null}
          <View>
            {typeof text === "string" ? (
              <ListItemTextPrimary>{text}</ListItemTextPrimary>
            ) : React.isValidElement(text) ? (
              text
            ) : null}
          </View>
          <Box ml={"auto"}>
            {typeof EndComponent === "function" ? (
              <EndComponent />
            ) : typeof EndComponent === "string" ? (
              <ListItemTextSecondary>{EndComponent}</ListItemTextSecondary>
            ) : React.isValidElement(EndComponent) ? (
              EndComponent
            ) : null}
          </Box>
        </Row>
      </ListItemContainer>
    )
  },
)

export function ListSubHeader({
  children,
  ...rest
}: HeadingProps): React.JSX.Element {
  return (
    <Heading colorScheme={"secondary"} variant={"h4"} {...rest}>
      {children}
    </Heading>
  )
}
